<template>
  <div class="box_sizing">
    <div class="premission_index">
      <el-row class="elAdd">
        <!-- <el-button
        type="primary"
        icon="el-icon-circle-plus-outline"
        @click="dialogFormVisible = true"
        >新增</el-button
      > -->
        <!-- <iframe class="prism-player" :src="'../../../static/pdf/web/viewer.html?file=' + 'http://hk.changhongit.com/pub/resource/application/2021060201744_c.pdf'" width="1000px" height="1000px"></iframe> -->
        <!-- <pdf src="./path/to/static/relativity.pdf"></pdf> -->
        <div class="search_div">
          <div>
            <el-input
              v-model="username"
              :class="[
                !activef
                  ? 'search_input colorchange'
                  : 'search_input searchchange',
              ]"
              size="medium "
              placeholder="病人姓名"
              @focus="f()"
              @blur="blurUsername()"
            >
              <i
                v-if="ffter == true"
                slot="prefix"
                class="el-input__icon el-icon-search"
              ></i>
              <i
                v-if="ffter == false"
                slot="prefix"
                style="color: #009b43"
                class="el-input__icon el-icon-search"
              ></i>
            </el-input>
            <el-input
              v-model="studyNo"
              :class="[
                !activeff
                  ? 'search_input colorchange'
                  : 'search_input searchchange',
              ]"
              size="medium "
              placeholder="检查号"
              @focus="fr()"
              @blur="blurUsernamer()"
            >
              <i
                v-if="ffterr == true"
                slot="prefix"
                class="el-input__icon el-icon-search"
              ></i>
              <i
                v-if="ffterr == false"
                slot="prefix"
                style="color: #009b43"
                class="el-input__icon el-icon-search"
              ></i>
            </el-input>
            <el-select
              v-model="modality"
              placeholder="检查类别"
              class="search_input"
              clearable
            >
              <el-option
                v-for="item in departmentOption"
                :key="item.desc"
                :label="item.desc"
                :value="item.desc"
              ></el-option>
            </el-select>
            <el-select
              v-model="partExamined"
              placeholder="检查部位"
              class="search_input"
              clearable
            >
              <el-option
                v-for="item in examinationSite"
                :key="item.id"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="hospitalId"
              placeholder="检查状态"
              class="search_input"
              clearable
            >
              <el-option
                v-for="item in hospitallist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              v-model="hospitalIdyiyuan"
              placeholder="检查医院"
              class="search_input"
              clearable
            >
              <el-option
                v-for="item in hospitallistyiyuan"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <div class="box_cycle">
              <span
                v-for="(item, index) in cycle"
                :key="index"
                @click="cycleChoice(item.name, item.id)"
                :class="
                  item.name == active ? 'active cyclestyle' : 'cyclestyle'
                "
              >
                {{ item.name }}
              </span>
              <span
                @click="dialogVisible = true"
                style="
                  color: #3eaf6a;
                  font-size: 14px;
                  cursor: pointer;
                  width: 90px;
                  height: 38px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img
                  style="width: 15px; height: 15px"
                  src="../../assets/日历@2x.png"
                  alt=""
                />
                更多
              </span>
            </div>
          </div>
          <div>
            <button
              type="primary"
              class="search_click"
              @click="getSearchList()"
            >
              搜索
            </button>
          </div>
        </div>
      </el-row>
      <!-- 表格 -->
      <el-table
        class="premission_table"
        :data="tableDatas"
        :row-class-name="tableRowClassName"
        @row-click="onRowClick"
        style="width: 100%"
        :header-cell-style="{ background: '#F9F9F9', color: '#999999' }"
      >
        <el-table-column type="index" label="序号" width="60" />
        <el-table-column prop="studyNo" label="检查号" width="180" />
        <el-table-column prop="username" label="姓名" width="120" />
        <!-- <el-table-column prop="gender" label="性别" /> -->
        <el-table-column prop="sex" label="性别" width="60">
          <template slot-scope="scope">
            {{ scope.row.gender == 0 ? "男" : "女" }}
          </template>
        </el-table-column>
        <el-table-column prop="studyAge" label="年龄" width="60" />
        <!-- <el-table-column prop="aiDiagnostic" label="AI判读（阴/阳）" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.aiDiagnostic == 0">判定中</span>
            <span v-if="scope.row.aiDiagnostic == 1">阳性</span>
            <span v-if="scope.row.aiDiagnostic == -1">阴性</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="studyModality" label="检查类型" />
        <!-- <el-table-column prop="partExamined" label="检查部位" width='170' /> -->
        <el-table-column prop="status" label="检查部位" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.partExamined == 'BREAST'">乳腺</span>
            <span v-if="scope.row.partExamined == 'HEAD'">头部</span>
            <span v-if="scope.row.partExamined == 'NECK'">颈部</span>
            <span v-if="scope.row.partExamined == 'CHEST'">胸部</span>
            <span v-if="scope.row.partExamined == 'ABDOMEN'">腹部</span>
            <span v-if="scope.row.partExamined == 'UPPER EXTREMITIES'"
              >上肢</span
            >
            <span v-if="scope.row.partExamined == 'LOWER EXTREMITIES'"
              >下肢</span
            >
          </template>
        </el-table-column>
        <!-- <el-table-column prop="hospitalName" label="检查状态" /> -->
        <el-table-column prop="processStatus" label="检查状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.processStatus == 0">收到影像</span>
            <span v-if="scope.row.processStatus == 1">AI判读完成</span>
            <span v-if="scope.row.processStatus == 2">报告编写中</span>
            <span v-if="scope.row.processStatus == 3">初步报告</span>
            <span v-if="scope.row.processStatus == 4">审核退回</span>
            <span v-if="scope.row.processStatus == 5">确认报告</span>
          </template>
        </el-table-column>
        <el-table-column prop="hospitalNames" label="检查医院" width="140" />
        <el-table-column prop="abnormal" label="阴阳性" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.abnormal == 0">阴性</span>
            <span v-if="scope.row.abnormal == 1">阳性</span>
            <span v-if="scope.row.abnormal != 1 && scope.row.abnormal != 0"
              >暂无</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="times" label="检查时间" width="180" />
        <el-table-column label="操作" fixed="right" width="130">
          <template slot-scope="scope">
            <el-button
              class="text_color"
              style="margin-left: 0px"
              v-if="scope.row.hasFilm == true"
              type="text"
              size="mini"
              @click="() => clicktudyInfo(scope.row)"
              >阅片</el-button
            >
            <el-button
              class="text_color"
              style="margin-left: 0px"
              v-if="scope.row.hasFilm == false"
              type="text"
              size="mini"
              @click="open"
              >阅片</el-button
            >
            <el-button
              class="text_color"
              style="margin-left: 0px"
              v-if="scope.row.studyModality == 'US'"
              type="text"
              size="mini"
              @click.stop="() => clicktudyInfovideo(scope.row)"
              >视频</el-button
            >

            <p
              class="ningcolor"
              v-if="scope.row.processStatus <= 2"
              @click.stop="() => warningclick(scope.row)"
            >
              报告
            </p>
            <p
              v-if="scope.row.hasHistoryReport"
              class="ningcolor"
              @click.stop="() => historyclick(scope.row)"
            >
              历史报告
            </p>
            <p
              class="ningcolor"
              v-if="
                scope.row.processStatus > 2 &&
                scope.row.processStatus != 4 &&
                scope.row.processStatus != 3
              "
              @click.stop="() => warningclicks(scope.row)"
            >
              查看报告
            </p>
            <p
              class="ningcolor"
              v-if="scope.row.processStatus == 3"
              @click.stop="() => warningclicks(scope.row)"
            >
              审核
            </p>
            <p
              class="ningcolor"
              v-if="scope.row.processStatus == 4"
              @click.stop="() => editwarningclicks(scope.row)"
            >
              查看报告
            </p>
            <p
              class="ningcolor"
              v-if="scope.row.studyModality == 'US'"
              @click.stop="() => clickultrasonic(scope.row)"
            >
              超声检查
            </p>
            <!-- <p
              class="green"

              @click.stop="() => AiOpen(scope.row)"
            >
              AI
            </p> -->
            <!-- <button

            type="text"
            size="mini"
            @click.stop="() => edit(scope.row)"
            >登记</button -->
            <!-- <p class='ningcolor' @click.stop="() => edit(scope.row)">登记</p> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 展示列表 -->
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          background=""
          layout="prev, pager, next"
          :total="totalPage"
          :current-page.sync="currentPage"
          @current-change="getMenuLinkageList(currentPage)"
        />
      </div>
      <!-- 添加弹框 -->
      <el-dialog title="时间选择" :visible.sync="dialogVisible" width="30%">
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="至"
          value-format="timestamp"
          start-placeholder="开始日期"
          unlink-panels="true"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <span slot="footer" class="dialog-footer">
          <el-button class="login_Edit" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            class="ok_Edit"
            @click="dialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 编辑弹框 -->
      <el-dialog
        top="15vh"
        title=""
        :visible.sync="dialogFormVisibleEdit"
        width="60%"
        :close-on-click-modal="false"
      >
        <div><h2 class="tan_header">基本资料</h2></div>
        <el-form :model="formEdit" :rules="rules" :inline="true" ref="formEdit">
          <!-- <el-form-item prop="content" label="公告内容:" :label-width="formLabelWidth">
          <el-input type="textarea" :row="3" placeholder="请输入公告内容" v-model="formEdit.content" autocomplete="off"></el-input>
        </el-form-item> -->
          <el-form-item
            prop="username"
            label="患者姓名:"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入节点名称"
              v-model="formEdit.username"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="gender"
            label="性别:"
            :label-width="formLabelWidth"
          >
            <el-select v-model="formEdit.gender" placeholder="请选择菜单类型">
              <el-option label="男" value="0" />
              <el-option label="女" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item
            prop="birthday"
            label="出生年月:"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              v-model="formEdit.birthday"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </el-form-item>
          <el-form-item
            prop="studyAge"
            label="年龄:"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入年龄"
              v-model="formEdit.studyAge"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="idcard"
            label="身份证号:"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入身份证号"
              v-model="formEdit.idcard"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="phone"
            label="联系电话:"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入联系电话"
              v-model="formEdit.phone"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <div v-text="formEdit.selected2"></div>
          <el-form-item
            prop="area_code"
            label="地区:"
            class="area_box"
            :label-width="formLabelWidth"
          >
            <area-cascader
              type="text"
              v-model="formEdit.selected2"
              :data="pca"
            ></area-cascader>
          </el-form-item>
          <el-form-item
            prop="street"
            label="详细地址:"
            :label-width="formLabelWidth"
          >
            <el-input
              width="200"
              placeholder="请输入详细地址"
              v-model="formEdit.street"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisibleEdit = false">取 消</el-button>
          <el-button type="primary" @click="postFormEdit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="details_right">
      <div class="patient_information">
        <div class="conentes">患者信息</div>
        <div v-if="rightPersonal" class="oatient_bottom">
          <div class="personal_content">
            <span>{{ rightConent.username }}</span>
            <span>{{ rightConent.gender == 0 ? "男" : "女" }}</span>
            <span>{{ rightConent.studyAge }}</span>
          </div>
          <div class="button_number">
            <div>检查号</div>
            <div class="Inspection">{{ rightConent.studyNo }}11</div>
          </div>
          <div class="button_number">
            <div>检查日期</div>
            <div class="Inspection">{{ rightConent.timesrt }}</div>
          </div>
          <div class="button_number">
            <div>检查类别</div>
            <div>{{ rightConent.studyModality }}</div>
          </div>
          <div class="button_number last_position">
            <div>检查部位</div>
            <!-- <div>{{ rightConent.partExamined }}</div> -->
            <span v-if="rightConent.partExamined == 'BREAST'">乳腺</span>
            <span v-if="rightConent.partExamined == 'HEAD'">头部</span>
            <span v-if="rightConent.partExamined == 'NECK'">颈部</span>
            <span v-if="rightConent.partExamined == 'CHEST'">胸部</span>
            <span v-if="rightConent.partExamined == 'ABDOMEN'">腹部</span>
            <span v-if="rightConent.partExamined == 'UPPER EXTREMITIES'"
              >上肢</span
            >
            <span v-if="rightConent.partExamined == 'LOWER EXTREMITIES'"
              >下肢</span
            >
          </div>
        </div>
        <div class="conentes conentebottom">诊断信息</div>
        <div v-if="rightPersonal" class="information">
          <span>{{ rightConent.diagnosis }}</span> <br />
          <span>{{ rightConent.symptom }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pca, pcaa } from "area-data";
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css";
// import { JSEncrypt } from 'jsencrypt';
// import JSEncrypt from 'jsencrypt'
// const JSEncrypt = require("JSEncrypt/bin/jsencrypt");
// const  encryptPublicLong  = require("@lsqswl/rsaencrypt");
import Encrypt from 'encryptlong'

// import { addAnnounce, deleteAnnounce, editAnnounce, announceList } from '@/api/shop.js'

export default {
  components: {
    VuePdfApp,
  },
  name: "Premission",
  data() {
    return {
      ffter: true,
      ffterr: true,
      activef: false,
      activeff: false,
      value1: [],
      num: 1,
      numone: 1,
      numtwo: 1,
      dialogVisible: false,
      rightConent: "",
      rightPersonal: false,
      checkUrl: "",
      pdfUrl: "",
      selected2: "",
      selected: [], //数组对应的就是选中的那个省市区。根据type来确定是省市区汉字的数组还是编码组成的数组。           //selected[0]省。selected[1]市。selected[2]区。
      pca: pca,
      pcaa: pcaa,
      area_code_array: "",
      times: "",
      regisactive: "未登记",
      day: "3",
      active: "一周内",
      cycle: [
        {
          name: "今天",
          id: 1,
        },
        {
          name: "三天内",
          id: 2,
        },
        {
          name: "一周内",
          id: 3,
        },
      ],
      hospitallist: [
        {
          name: "收到影像",
          id: 0,
        },
        {
          name: "AI判读完成",
          id: 1,
        },
        {
          name: "报告编写中",
          id: 2,
        },
        {
          name: "初步报告",
          id: 3,
        },
        {
          name: "审核退回",
          id: 4,
        },
        {
          name: "确认报告",
          id: 5,
        },
      ],
      hospitallistyiyuan: [],
      partExamined: "",
      hospitalId: "",
      hospitalIdyiyuan: "",
      modality: "",
      departmentOption: [],
      examinationSite: [
        {
          name: "头部",
          id: 1,
          value: "HEAD",
        },
        {
          name: "颈部",
          id: 2,
          value: "NECK",
        },
        {
          name: "胸部",
          id: 3,
          value: "CHEST",
        },
        {
          name: "腹部",
          id: 4,
          value: "ABDOMEN",
        },
        {
          name: "乳腺",
          id: 5,
          value: "BREAST",
        },
        {
          name: "上肢",
          id: 6,
          value: "UPPER EXTREMITIES",
        },
        {
          name: "下肢",
          id: 7,
          value: "LOWER EXTREMITIES",
        },
      ],
      listlist: "",
      keysEdit: [],
      tableDatas: [],
      studyNo: "",
      menuList: "",
      propd: {
        multiple: true,
        label: "name",
        value: "id",
      },
      optionss: [
        {
          value: 1,
          label: "东南",
          children: [
            {
              value: 2,
              label: "上海",
              children: [
                { value: 3, label: "普陀" },
                { value: 4, label: "黄埔" },
                { value: 5, label: "徐汇" },
              ],
            },
            {
              value: 7,
              label: "江苏",
              children: [
                { value: 8, label: "南京" },
                { value: 9, label: "苏州" },
                { value: 10, label: "无锡" },
              ],
            },
            {
              value: 12,
              label: "浙江",
              children: [
                { value: 13, label: "杭州" },
                { value: 14, label: "宁波" },
                { value: 15, label: "嘉兴" },
              ],
            },
          ],
        },
        {
          value: 17,
          label: "西北",
          children: [
            {
              value: 18,
              label: "陕西",
              children: [
                { value: 19, label: "西安" },
                { value: 20, label: "延安" },
              ],
            },
            {
              value: 21,
              label: "新疆维吾尔族自治区",
              children: [
                { value: 22, label: "乌鲁木齐" },
                { value: 23, label: "克拉玛依" },
              ],
            },
          ],
        },
      ],
      propss: {
        multiple: true,
        children: "children",
        checkStrictly: true,
        label: "name",
        value: "name",
      },
      isAllSelect: false,
      keys: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      pstlist: "",
      permissionOptions: [],
      checkList: "",
      options: "",
      username: "",
      totalPage: 0,
      currentPage: 1,
      tableData: [],
      dialogFormVisible: false,
      dialogFormVisibleEdit: false,
      formLabelWidth: "120px",
      list: "",
      formEditlist: [],
      formEdit: {
        id: "",
        // content:"",
        // visible: "",
        // index: "",
        hospitalIds: "",
        // url: "",
        // icon: "",
        username: "",
        idcard: "",
        phone: "",
        street: "",
        selected2: "",
        studyAge: "",
        grade: "",
        gender: "",
        birthday: "",
        pid: "",
        remark: "",
        pstlist: "",
        permissions: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入患者姓名", trigger: "blur" },
        ],
        idcard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        street: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        // studyAge: [{ required: true, message: "请输入患者年龄", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
      },
    };
  },
  created() {
    console.error(
      "this.$router.currentRoute.query.username",
      this.$router.currentRoute.query.username
    );
    if (
      this.$router.currentRoute.query.username == "" ||
      this.$router.currentRoute.query.username
    ) {
      console.error(
        "this.$router.currentRoute",
        this.$router.currentRoute.query
      );
      this.username = this.$router.currentRoute.query.username;
      this.value1[0] = this.$router.currentRoute.query.startTime;
      this.value1[1] = this.$router.currentRoute.query.endTime;
      this.currentPage = this.$router.currentRoute.query.currentPage;
      this.day = this.$router.currentRoute.query.day;
      if (this.$router.currentRoute.query.hospitalIdyiyuan != "") {
        this.hospitalIdyiyuan = Number(
          this.$router.currentRoute.query.hospitalIdyiyuan
        );
      }
      this.modality = this.$router.currentRoute.query.modality;
      this.studyNo = this.$router.currentRoute.query.studyNo;
      this.partExamined = this.$router.currentRoute.query.partExamined;
      if (this.$router.currentRoute.query.hospitalId != "") {
        this.hospitalId = Number(this.$router.currentRoute.query.hospitalId);
      }
    }
    //this.getCdlist();
    // this.getMenuLinkageList();

    let username = this.$route.query.ultrasound_username;
    if(username && username.length>0){
      this.username = username;
      this.day=3;
      this.value1[0]=new Date().getTime()-1000*60*60*24*365*2;
      this.value1[1]=new Date().getTime();
    }

    this.getMenuLinkageList();
    this.getPermissionList();
    // 获取医院权限列表 搜索用
    this.getListMyHospital();
    depot
      .get({
        url: "/v1/devices/types",
        params: {
          token: sessionStorage.getItem("token"),
        },
      })
      .then((res) => {
        this.departmentOption = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  watch: {
    formEditlist(newVal) {
      this.formEdit.hospitalIds = newVal.join();
      console.log(this.formEdit.hospitalIds);
    },
    list(newVal) {
      this.form.hospitalIds = newVal.join();
      console.log(this.form.hospitalIds);
    },
  },
  methods: {

    visibilityChange(val) {
      let _len = val.length;
      return val.substring(0, 1) + "****" + val.substring(_len - 1, _len);
    },
    clickultrasonic(row) {
      this.onRowClick(row,2);
    },
    f() {
      console.log("123");
      this.ffter = false;
      this.activef = true;
    },
    blurUsername() {
      console.log("222");
      this.ffter = true;
      this.activef = false;
    },
    fr() {
      console.log("123");
      this.ffterr = false;
      this.activeff = true;
    },
    blurUsernamer() {
      console.log("222");
      this.ffterr = true;
      this.activeff = false;
    },
    open() {
      this.$message("暂无影像");
    },
    getListMyHospital() {
      depot
        .get({
          url: "/v1/hospital/listMyHospital",
          params: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.hospitallistyiyuan = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      return Y + M + D;
    },
    AiOpen(val) {
      // window.open('http://101.91.215.98:8000/work.html?studyId='+ val.studyNo +'&patientName=&studyBiRads=&studyState=3&beginTime=&endTime=');
      window.open(
        "http://47.100.254.72:8000/index.html?studyNo=0005130582&patientName=&studyBiRads=&studyState=3&beginTime=&endTime="
      );
    },
    clicktudyInfo(data) {
      console.log(data);
      var width = window.screen;
      var height = window;
      console.log("window.screenX1", width);
      console.log("window.screenY2", height);
      if (data.studyModality == "MG") {
        let { href } = this.$router.resolve({
          path: "/usreport",
          query: {
            userId: data.studyId,
          },
        });
        var width = 10000;
        var Height = 10000;
        var left = 2200;
        console.log("window.screenX", window.screen.availWidth);
        console.log("window.screenY", window.screen.availHeight);

        left += window.screenX;
        try {
          this["pageNum" + this.num] = window.open(
            href,
            "",
            "width=" +
              width +
              ", height=" +
              Height +
              ", top=0, left=" +
              left +
              ", screenX=0,screenY=0,toolbar=no,status=no,location=no,directories=no,menubar=no,titlebar=no,fullscreen=yes,channelmode=yes,copyhistory=no"
          );
          if (this.num === 1) {
            this.num = 2;
          } else {
            this.num = 1;
          }
          this["pageNum" + this.num].close();
        } catch (e) {
          //
        }
      } else {
        let { href } = this.$router.resolve({
          path: "/report",
          query: {
            userId: data.studyId,
          },
        });
        var width = 10000;
        var Height = 10000;
        var left = 2200;
        console.log("window.screenX", window.screenX);
        left += window.screenX;
        try {
          this["pageNum" + this.num] = window.open(
            href,
            "",
            "width=" +
              width +
              ", height=" +
              Height +
              ", top=0, left=" +
              left +
              ", screenX=0,screenY=0,toolbar=no,status=no,location=no,directories=no,menubar=no,titlebar=no,fullscreen=yes,channelmode=yes,copyhistory=no"
          );
          if (this.num === 1) {
            this.num = 2;
          } else {
            this.num = 1;
          }
          this["pageNum" + this.num].close();
        } catch (e) {
          //
        }
      }

      // var scrWidth = window.screen.availWidth;
      // var scrHeight = window.screen.availHeight;
      // window.open(href, '', 'width=' + scrWidth + ', height=' + scrHeight + ', top=0, left=' + scrWidth + ', screenX=0,screenY=0,toolbar=no,status=no,location=no,directories=no,menubar=no,titlebar=no,fullscreen=yes,channelmode=yes,copyhistory=no');
      // window.open(href,'windowName','resizable=1,scrollbars=1,fullscreen=0,height=13000,width=' + width + '  , left=' + left + ', toolbar=0, menubar=0,status=1,');
      //  window.open(href, '', 'width=' + width + ', height=' + Height + ', top=0, left=' + left + ', screenX=0,screenY=0,toolbar=no,status=no,location=no,directories=no,menubar=no,titlebar=no,fullscreen=yes,channelmode=yes,copyhistory=no');
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    onRowClick(row,type) {
      console.log('row',row);
      this.rightPersonal = true;
      console.log(row);
      // this.rightConent = row
      depot
        .get({
          url: "/v1/study/getStudy",
          params: {
            token: sessionStorage.getItem("token"),
            id: row.studyId,
          },
        })
        .then((res) => {
          console.log("1", res);
          this.rightConent = res.data;
          this.bbbb = res.data.birthday
          console.error('bbbbb',this.bbbb);
          // this.rightConent.times = this.time(this.rightConent.studyDatetime);
          this.rightConent.timesrt = this.timestampToTime(
            this.rightConent.studyDatetime
          );
          console.error('2333',this.bbbb);
      //  let publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjylFrtRp6mbSPelQL6wVx5bTZrecwKbRTN1uesdQrq5O9l5ucOSebg1czUAYuJnGZGT5H344AAe4ETjYFNTDTq0zk2cYj0YS5GJl6NXZiYUieKQksAPX4M75wOXd7dtFKufEyV7g98K/beWV9oRV0G2YDq+GbO37Ym8cRJbtYZiHjeB9JhGCYos8uNdzaorHMCh6L3yH+qE3gZF/iJVp6biRn9nurN1T+9foOg8HFm6cYPAF9weYEt+F+Gre6Qyd1IgYS5Tt25nSCkSAmwsDT7Ic9yeuAZFzpHh01dp52ngGVxEcKxSS5y/e5dxBiOr3pp2zm9x52IbQ+BiwNGYVpwIDAQAB'
       let publicKey = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjylFrtRp6mbSPelQL6wVx5bTZrecwKbRTN1uesdQrq5O9l5ucOSebg1czUAYuJnGZGT5H344AAe4ETjYFNTDTq0zk2cYj0YS5GJl6NXZiYUieKQksAPX4M75wOXd7dtFKufEyV7g98K/beWV9oRV0G2YDq+GbO37Ym8cRJbtYZiHjeB9JhGCYos8uNdzaorHMCh6L3yH+qE3gZF/iJVp6biRn9nurN1T+9foOg8HFm6cYPAF9weYEt+F+Gre6Qyd1IgYS5Tt25nSCkSAmwsDT7Ic9yeuAZFzpHh01dp52ngGVxEcKxSS5y/e5dxBiOr3pp2zm9x52IbQ+BiwNGYVpwIDAQAB"
      var data = {
studyId:row.studyId,
token:"eyJhbGciOiJIUzUxMiJ9.eyJpZCI6NjkyLCJ0b2tlbiI6IjMzZDVmZDIxLWIxMjAtNDAzOC1iYTBmLTVkMDdlODA5MzAxZiIsImV4cGlyZSI6MTY4MDY4NDc3MzY5OH0.LS1L4HfB-b98dg1mMLs1z1Wox16hz-HWdCn-o6Cx1L8J6Xb1FqIEX05zjneTXZ5mRxD9PSayk6RR_2dRfS72Fg",
patient: {
                                username: row.username,
                                gender: row.gender,
                                age: row.studyAge,
                                birthDay: this.bbbb,
                            },
                            study: {
                                studyNo: row.studyNo,
                                modality: row.studyModality,
                                partExamined: row.partExamined,
                                studyDateTime: row.times,
                            }
}
if(type == 2){
  const PUBLIC_KEY = publicKey
    var encryptor = new Encrypt()
    encryptor.setPublicKey(PUBLIC_KEY)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    const result = encryptor.encryptLong(JSON.stringify(data));
  console.log('result',result)

      // var url = 'https://qa.yh-med.cn:82/static/ultrasonic.html' + '?id=' + row.studyId + '&token=' + sessionStorage.getItem("token")
      this.http.post('http://localhost:9091/v1/client/ultrasound/do-check', {
        data:result
      })
      		.then(response => {

        // this.$refs["upload"].$refs["upload-inner"].handleChangeedit()
      		})
      		.catch(err => {
      			console.error(err);
      		});
        this.http.post('http://localhost:9091/v1/client/ultrasound/do-check/' + '?url=' + 'http://0.0.0.0:8080/#/ultrasonic'+'?id=' + row.studyId + '&token=' + sessionStorage.getItem("token"))
       .then(response => {

       })
       .catch(err => {
        console.error(err);
       });
}
        })
        .catch((err) => {
          console.log(err);
        });
    },
    warningclick(row) {
      let routeUrl = this.$router.resolve({
        path: "/imagetext",
        query: {
          id: row.studyId,
          hasHistoryReport:row.hasHistoryReport,
          patientId: row.patientId,
          studyModality: row.studyModality,
        },
      });

      try {
        this["pageNumone" + this.numone] = window.open(routeUrl.href, "_blank");
        if (this.numone === 1) {
          this.numone = 2;
        } else {
          this.numone = 1;
        }
        this["pageNumone" + this.numone].close();
      } catch (e) {
        //
      }
      // window.open(routeUrl.href, '_blank')

      //   let { href } = this.$router.resolve({
      //   path: "/imagetext",
      //   query: {
      //       id: row.studyId,
      //     studyModality:row.studyModality,
      //   },
      // });
      // var scrWidth = window.screen.availWidth;
      // var scrHeight = window.screen.availHeight;
      // window.open(href, '', 'width=' + scrWidth + ', height=' + scrHeight + ', top=0, left=' + scrWidth + ', screenX=0,screenY=0,toolbar=no,status=no,location=no,directories=no,menubar=no,titlebar=no,fullscreen=yes,channelmode=yes,copyhistory=no');
    },
    clicktudyInfovideo(row) {
      // let { href } = this.$router.resolve({
      //   path: "/usvideo",
      //   query: {
      //     id: row.studyId,
      //   },
      // });
      // var scrWidth = window.screen.availWidth;
      // var scrHeight = window.screen.availHeight;
      // window.open(href, '', 'width=' + scrWidth + ', height=' + scrHeight + ', top=0, left=' + scrWidth + ', screenX=0,screenY=0,toolbar=no,status=no,location=no,directories=no,menubar=no,titlebar=no,fullscreen=yes,channelmode=yes,copyhistory=no');

      let { href } = this.$router.resolve({
        path: "/usvideo",
        query: {
          id: row.studyId,
        },
      });
      var width = 10000;
      var Height = 10000;
      var left = 2200;
      console.log("window.screenX", window.screenX);
      left += window.screenX;
      try {
        this["pageNum" + this.num] = window.open(
          href,
          "",
          "width=" +
            width +
            ", height=" +
            Height +
            ", top=0, left=" +
            left +
            ", screenX=0,screenY=0,toolbar=no,status=no,location=no,directories=no,menubar=no,titlebar=no,fullscreen=yes,channelmode=yes,copyhistory=no"
        );
        if (this.num === 1) {
          this.num = 2;
        } else {
          this.num = 1;
        }
        this["pageNum" + this.num].close();
      } catch (e) {
        //
      }
    },
    historyclick(row){
      console.log(row);
      let routeUrls = this.$router.resolve({
        path: "/lookimagehistory",
        query: {
          patientId: row.patientId,
        },
      });
      try {
        this["pageNumtwo" + this.numtwo] = window.open(
          routeUrls.href,
          "_blank"
        );
        if (this.numtwo === 1) {
          this.numtwo = 2;
        } else {
          this.numtwo = 1;
        }
        this["pageNumtwo" + this.numtwo].close();
      } catch (e) {
        //
      }
    },
    warningclicks(row) {
      console.log(row);
      let routeUrls = this.$router.resolve({
        path: "/lookimagetext",
        query: {
          id: row.studyId,
          patientId:row.patientId,
          hasHistoryReport:row.hasHistoryReport,
          username: this.username,
          studyNo: this.studyNo,
          modality: this.modality,
          partExamined: this.partExamined,
          status: this.hospitalId,
          hospitalId: this.hospitalIdyiyuan,
          day: this.day,
          startTime: this.value1[0],
          endTime: this.value1[1],
          page: this.currentPage,
          studyModality: row.studyModality,
        },
      });
      try {
        this["pageNumtwo" + this.numtwo] = window.open(
          routeUrls.href,
          "_blank"
        );
        if (this.numtwo === 1) {
          this.numtwo = 2;
        } else {
          this.numtwo = 1;
        }
        this["pageNumtwo" + this.numtwo].close();
      } catch (e) {
        //
      }
    },
    editwarningclicks(row) {
      console.log(row);
      this.$router.push({
        path: "/editimageText",
        query: {
          id: row.studyId,
          patientId: row.patientId,
          hasHistoryReport: row.hasHistoryReport,
          username: this.username,
          studyNo: this.studyNo,
          modality: this.modality,
          partExamined: this.partExamined,
          status: this.hospitalId,
          hospitalId: this.hospitalIdyiyuan,
          day: this.day,
          startTime: this.value1[0],
          endTime: this.value1[1],
          page: this.currentPage,
        },
      });
    },
    cycleChoice(name, id) {
      this.active = name;
      console.log(id);
      this.day = id;
    },
    getMenuIdsEdit() {
      // let menuIds = this.$refs.menusTree.getCheckedKeys()
      // this.roleForm.menu_ids = menuIds
      if (Array.isArray(this.$refs.menusTreeEdit.getCheckedKeys())) {
        this.formEdit.permissions = this.$refs.menusTreeEdit
          .getCheckedKeys()
          .join();
      }
      console.log(this.formEdit.permissions);
    },
    getCdlist() {
      depot
        .post({
          url: "/backend/menu/getMenus",
          data: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.data;
          console.log(this.tableData);
          this.menuList = JSON.parse(JSON.stringify(res.data));
          // this.options.forEach((val, index) => {
          //   val.children.forEach((valus, index) => {
          //     delete valus.children;
          //   });
          //   // delete val.children
          // });
          console.log(this.menuList);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    edit(data) {
      // let { type, id, parent_id, title, icon, path, vue_route, permissions } = data
      console.log(data);
      this.$router.push({
        path: "/study/record/add",
        query: {
          userId: data.studyId,
        },
      });
      // this.dialogFormVisibleEdit = true;
      // this.formEdit = data;
      // this.formEditlist = data.hospitalIds.split(",");
      // var str = "";
      // var arrays = "";
      // data.permissions.map((item) => {
      //   str = str + item.menuId + ",";
      // });
      // str =
      //   str.substring(str.length - 1) == ","
      //     ? str.substring(0, str.length - 1)
      //     : str;
      // console.log(str);
      // this.keysEdit = str.split(",").map(Number);
      // this.formEdit.permissions = str.split(",").map(Number).join();
      // console.log(this.keysEdit);
      // console.error(this.formEdit.permissions);
      // console.log(data.permissions);
      // this.formEditlist = arr.map(item => item.split(':'))
      // this.formEdit.pstlist = data.permissions;
      // console.log(this.formEdit);
      // depot
      //   .get({
      //     url: "/v1/study/getStudy",
      //     params: {
      //       token: sessionStorage.getItem("token"),
      //       id: data.studyId,
      //     },
      //     config: {},
      //   })
      //   .then((res) => {
      //     console.log(res);
      //     this.formEdit = res.data;
      //   });
      // menuDetail({
      //   sign: '111',
      //   token: sessionStorage.getItem('token'),
      //   id: data.id
      // })
      //   .then(res => {
      //     this.editForm = res.data
      //     this.editForm.sign = '111'
      //     this.editForm.token = sessionStorage.getItem('token')
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
      // this.getMenuLinkageList(data.type)
    },
    getMenuIds() {
      // let menuIds = this.$refs.menusTree.getCheckedKeys()
      // this.roleForm.permissions = menuIds
      if (Array.isArray(this.$refs.menusTree.getCheckedKeys())) {
        console.log(this.$refs.menusTree.getCheckedKeys());
        this.form.permissions = this.$refs.menusTree.getCheckedKeys().join();
      }
      console.log(this.form.permissions);
    },
    deleteClick(val) {
      console.log(val);
      depot
        .post({
          url: "/backend/role/delete",
          data: {
            id: val.id,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.success == true) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getMenuLinkageList();
            return;
          }
          this.$message({
            message: res.msg,
            type: "error",
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    time(time = +new Date()) {
      var date = new Date(time + 8 * 3600 * 1000);
      return date.toJSON().substr(0, 19).replace("T", " ").replace(/-/g, "-");
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    handleChange() {
      console.log(this.value);
    },
    getMenuLinkageList(page = 1, page_num = 10) {
      // console.log(value);
      depot
        .get({
          url: "/v1/study/listCompleteStudies",
          params: {
            page: page,
            pageSize: page_num,
            token: sessionStorage.getItem("token"),
            day: this.day,
            // status: this.regis_id,
            startTime: this.value1[0],
            endTime: this.value1[1],
            status: this.hospitalId,
            hospitalId: this.hospitalIdyiyuan,
            partExamined: this.partExaminned,
            modality: this.modality,
            studyNo: this.studyNo,
            username: this.username,
          },
        })
        .then((res) => {
          console.log(res);
          this.totalPage = (res.data.count / page_num) * 10;
          console.error(this.totalPage);
          this.tableDatas = res.data.list;
          console.error('111',this.tableDatas);
          this.tableDatas.forEach((element) => {
            //console.log(this.time(element.studyDatetime));
            element.times = this.time(element.studyDatetime);
            element.hospitalNames = this.visibilityChange(element.hospitalName);
            element.timesrt = this.timestampToTime(element.studyDatetime);
            console.log(element.timesrt);
          });
          // this.currentPage = 1
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPermissionList(value) {
      // console.log(value);
      depot
        .get({
          url: "/v1/hospital/listHospital",
          params: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log(res.data);
          this.permissionOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSearchList(page = 1, page_num = 10) {
      depot
        .get({
          url: "/v1/study/listCompleteStudies",
          params: {
            page: page,
            pageSize: page_num,
            token: sessionStorage.getItem("token"),
            username: this.username,
            studyNo: this.studyNo,
            modality: this.modality,
            partExamined: this.partExamined,
            status: this.hospitalId,
            hospitalId: this.hospitalIdyiyuan,
            day: this.day,
            startTime: this.value1[0],
            endTime: this.value1[1],
          },
        })
        .then((res) => {
          console.log(res);
          this.totalPage = (res.data.count / page_num) * 10;
          this.tableDatas = res.data.list;
          console.log(this.tableDatas);
          this.tableDatas.forEach((element) => {
            console.log(this.time(element.studyDatetime));
            element.times = this.time(element.studyDatetime);
            element.hospitalNames = this.visibilityChange(element.hospitalName);
            element.timesrt = this.timestampToTime(element.studyDatetime);
            console.log(element.timesrt);
          });
          this.currentPage = 1;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postForm() {
      console.log(this.list);
      //  this.form.permissions.forEach((val, index) => {
      //       console.log(val);
      //       // delete val.children
      // });
      // let str = "";
      // for (var i = 0; i < this.permissions.length; i++) {
      //   str += this.permissions[i] + "|";
      //   var newlist = str.replace(/\,/g, ":");
      //   this.form.permissions = newlist.replace(/\|/g, ",");
      //   // this.form.permissions = this.form.permissions.substr(0,this.form.permissions.length-1);
      //   console.log(this.form.permissions);
      // }
      // this.form.hospitalIds = this.list.map(item => item.join(':')).join(',');
      // console.log(this.list.map(item => item.join(':')).join(','));
      // console.log(this.form.hospitalIds);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/backend/role/save",
              data: this.form,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.dialogFormVisible = false;
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: "新增失败",
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
          // addAnnounce(this.form).then(res => {
          //   this.$message({
          //     message:res.message,
          //     type:"success",
          //     duration:2000
          //   })
          //   this.dialogFormVisible = false;
          //   this.getMenuLinkageList(this.currentPage);
          //   this.$refs["form"].resetFields();
          // }).catch(err => {
          //   console.log(err)
          // })
        }
      });
    },
    handleDelete(row) {
      this.$confirm("是否确认删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAnnounce({
            id: row.id,
          })
            .then((res) => {
              this.getMenuLinkageList(this.currentPage);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    handleEdit(row) {
      let {
        id,
        username,
        idcard,
        selected2,
        phone,
        street,
        studyAge,
        grade,
        pid,
        remark,
        gender,
        birthday,
      } = row;
      this.formEdit.id = id;
      // this.formEdit.content = content
      this.formEdit.username = username;
      this.formEdit.idcard = idcard;
      this.formEdit.phone = phone;
      this.formEdit.street = street;
      this.formEdit.selected2 = selected2;
      this.formEdit.studyAge = studyAge;
      this.formEdit.pid = pid;
      this.formEdit.remark = remark;
      // this.formEdit.pstlist = pstlist;
      // this.formEdit.pstlist = permissions;
      // this.formEdit.visible = visible;
      // this.formEdit.index = index;
      // this.formEdit.url = url;
      this.formEdit.grade = grade;
      this.formEdit.gender = gender;
      this.formEdit.birthday = birthday;
      this.dialogFormVisibleEdit = true;
    },
    postFormEdit() {
      console.error(this.formEdit.permissions);
      // this.formEdit.hospitalIds = this.formEditlist.map(item => item.join(':')).join(',');
      // console.log(this.formEditlist.map(item => item.join(':')).join(','));
      // console.log(this.formEdit.hospitalIds);
      this.$refs["formEdit"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/backend/role/update",
              data: this.formEdit,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: res.data,
                  type: "success",
                });
                this.dialogFormVisibleEdit = false;
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: "修改失败",
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
          // editAnnounce(this.formEdit)
          //   .then((res) => {
          //     this.$message({
          //       message: res.message,
          //       type: "success",
          //       duration: 2000,
          //     });
          //     this.dialogFormVisibleEdit = false;
          //     this.getMenuLinkageList(this.currentPage);
          //     this.$refs["formEdit"].resetFields();
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
        }
      });
    },
  },
};
</script>

<style scoped>
.information {
  padding: 20px 20px 0px 20px;
  box-sizing: border-box;
}
.last_position {
  margin-bottom: 20px;
}
.button_number div:last-child {
  color: #000;
}
.button_number div:first-child {
  color: #7e7e7e;
  width: 65px;
  margin-right: 15px;
  text-align: right;
}
.button_number {
  display: flex;
  margin-top: 10px;
  align-items: center !important;
  height: 22px !important;
}
.personal_content span {
  margin-right: 22px;
}
.personal_content {
  display: flex;
}
.oatient_bottom {
  padding: 24px 0px 24px 20px;
  box-sizing: border-box;
}
.patient_information .conentes {
  background: rgb(0, 155, 67, 0.05);
  padding: 7px 0px 7px 19px;
  color: #000;
  box-sizing: border-box;
  box-shadow: 1px 2px 8px 2px rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgb(238, 233, 233);
}
.conentebottom {
  margin-top: 20px;
}
.box_sizing {
  display: flex;
  justify-content: space-between;
}
.details_right {
  width: 18.5%;
  height: 90vh;
  background: #fff;
  margin-top: 10px;
  box-shadow: 1px 2px 8px 2px rgba(0, 0, 0, 0.05);
}
.text_color {
  font-size: 14px;
}
.ningcolor {
  color: #e6a23c;
  cursor: pointer;
  display: inline-block;
  font-weight: 500;
}
.tan_header {
  margin-left: 40px;
  margin-bottom: 15px;
}
/deep/.area_box .area-select .area-selected-trigger {
  padding: 0px 10px !important;
}
.search_click {
  color: #fff;
  width: 100px;
  height: 40px;
  background: #009b43;
  border: none;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  border-radius: 3px;
}
.search_click:hover {
  border-radius: 3px;
  background-image: linear-gradient(
    to right,
    #0ba360,
    #3cba92,
    #30dd8a,
    #2bb673
  );
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
  background-position: 100% 0;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}
.box_cycle {
  display: inline-flex;
  align-items: center;
  border: 1px solid #dddddd;
  border-radius: 3px;
  margin-top: 5px;
}
.box_regis {
  display: inline-flex;
  /* margin-bottom: 28px; */
}
.box_cycle span:first-child {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-right: 1px solid #dddddd;
}
.box_cycle span:nth-child(3) {
  border-left: 1px solid #dddddd;
}
.box_cycle span:last-child {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border-left: 1px solid #dddddd;
}
.premission_index {
  width: 80%;
  padding: 20px;
  background: #fff;
  margin-top: 10px;
  box-sizing: border-box;
}
.search_div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search_input {
  width: 120px;
}
.premission_table {
  margin-top: 10px;
}
/deep/.el-input--medium .el-input__inner {
  height: 40px !important;
}
.pagination_box {
}
.pagination {
  padding: 0 20px;
  margin-top: 20px;
  text-align: right;
}
.elAdd {
  margin-bottom: 10px;
}
.cyclestyle {
  cursor: pointer;
  width: 90px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999999;
  background: #fff;
  font-size: 14px;
  opacity: 0.8;
}
.active {
  background: #009b43;
  cursor: pointer;
  color: #fff;
}
.register {
  cursor: pointer;
  /* width: 139px; */
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  /* background: #c4c4c4; */
  font-size: 14px;
  opacity: 0.8;
}
/*
 */
.registeractive {
  cursor: pointer;
  color: #fff;
  background: #009b43;
}
.statusone {
  color: #ed6f00 !important;
}
/deep/.pagination .btn-prev {
  display: none !important;
}
/deep/.pagination .btn-next {
  display: none !important;
}
/deep/.pagination .el-pager li:hover {
  color: #000 !important;
}
/deep/.pagination .el-pager .active {
  background: #3eaf6a !important;
  color: #fff !important;
}
/deep/.el-pagination.is-background .el-pager .number {
  background: #eeeeee !important;
  color: #999999 !important;
}
/deep/.el-pagination.is-background .el-pager .active {
  background: #3eaf6a !important;
  color: #fff !important;
}
.Inspection {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.green {
  color: #009b43 !important;
  cursor: pointer;
  display: inline-block;
}
.information span {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  word-break: break-all;
  -webkit-box-orient: vertical;
}
.login_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  background: #eeeeee;
  border-radius: 4px;
  border: none;
  color: #999999;
}
.ok_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  background: #009b43;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  margin-left: 30px;
  color: #fff;
}
/deep/ .colorchange .el-input__inner::-webkit-input-placeholder {
  color: #cccfd5;
}

/deep/ .searchchange .el-input__inner::-webkit-input-placeholder {
  color: #009b43;
}
/deep/.el-select .el-input .el-select__caret.is-reverse {
  color: #009b43 !important;
}
</style>




// WEBPACK FOOTER //
// src/views/history/index.vue